import BaseDialogHtml from "../../BaseDialog/BaseDialogHtml.js";
import {createOrgNameUrlTemplate} from "../../../js/util/UrlUtils.js";
import {safeText} from "../../../js/util/CommonUtils.js";

export default class FailedInjectionsDialog {
    #html = new BaseDialogHtml();
    /** @type {string} */
    #orgName;
    /** @type {number} */
    #injectionsNumber = 0;

    /**
     * @param {string} orgName
     * @param {FailedBatchResources[]} failedBatchResources
     */
    show(orgName, failedBatchResources) {
        this.#orgName = orgName;
        this.#html.show({
            title: "You don't have access to these injections:",
            bodyHtml: this.#getBodyHtml(failedBatchResources),
            cssClass: "forbidden-injections-dialog",
            btnOk: "Refresh",
            btnCancel: "Close"
        })
        this.#html.onOk(()=> location.reload())
    }

    /** @param callback */
    onCancel(callback){
        this.#html.onCancel(callback)
    }

    /**
     * @param {FailedInjection} forbiddenInjection
     * @returns {string}
     */
    #createInjectionLinkRow(forbiddenInjection){
        this.#injectionsNumber++;
        const linkText = safeText(forbiddenInjection.name) || forbiddenInjection.id;
        return `
            <div class="forbidden-injections-dialog__row">
                <a class="forbidden-injections-dialog__link" href="${createOrgNameUrlTemplate(this.#orgName)}/injection/${forbiddenInjection.id}">${linkText}</a>
            </div>
        `
    }

    /**
     * @param {FailedBatchResources} failedBatchResource
     * @returns {string}
     */
    #createBatchBlock(failedBatchResource){
        if (this.#injectionsNumber >= 100)
            return ''
        const nameText = failedBatchResource.batchName || failedBatchResource.batchId;
        return `
            <div class="forbidden-injections-dialog__batch-block">
                <div class="forbidden-injections-dialog__batch-name">In batch ${safeText(nameText)}:</div>
                ${failedBatchResource.failedNestedResources.map(i => this.#createInjectionLinkRow(i)).join('')}
            </div>
        
        `
    }

    /**
     * @param {FailedBatchResources[]} failedBatchResources
     * @returns {string}
     */
    #getBodyHtml(failedBatchResources){
        const allFailedInjections = [];
        for (const failedResource of failedBatchResources){
            allFailedInjections.push(...failedResource.failedNestedResources)
        }
        const injectionsForDialog = allFailedInjections.slice(0, 100);
        return `
            <div class="dialog-content forbidden-injections-dialog__content">
                ${failedBatchResources.map(i => this.#createBatchBlock(i)).join('')}
            </div>`
    }

}